import { UrlMapperValidators } from '../validator';
export var maxLengthValidator = function (value) {
    return (value === null || value === void 0 ? void 0 : value.length) <= UrlMapperValidators.MAX_URL_MAPPING_LENGTH;
};
//# sourceMappingURL=max-length-validator.js.map